import { render, staticRenderFns } from "./need-review.vue?vue&type=template&id=548ee8ee&"
import script from "./need-review.vue?vue&type=script&lang=js&"
export * from "./need-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports